/**
 * Etapas da renovação 2026. Vivem em estado local da página (não vão para a URL):
 * recarregar recomeça na identificação e exige novo código.
 */
export type RenewalStep = 'identify' | 'verify' | 'review' | 'payment' | 'processing' | 'photos' | 'outcome';

/** Estado do código na etapa `verify`. */
export type RenewalCodeStatus = 'idle' | 'verifying' | 'error' | 'success';

/** Largura da barra de progresso do header por etapa (Figma 2079:6265: ~24% na identificação). */
const PROGRESS_BY_STEP: Record<RenewalStep, number> = {
  identify: 24,
  verify: 40,
  review: 60,
  payment: 80,
  processing: 90,
  photos: 95,
  outcome: 100
};

const PREVIOUS_STEP: Partial<Record<RenewalStep, RenewalStep>> = {
  verify: 'identify',
  review: 'verify',
  payment: 'review'
};

export function getRenewalProgressPercent(step: RenewalStep): number {
  return PROGRESS_BY_STEP[step];
}

/** Etapa para onde o «Voltar» do header leva; `null` quando o header não mostra «Voltar». */
export function getPreviousRenewalStep(step: RenewalStep): RenewalStep | null {
  return PREVIOUS_STEP[step] ?? null;
}

/** Processamento, fotos (pagamento já feito) e desfechos não têm «Voltar», para não reenviar o pagamento. */
export function isRenewalOutcomeStep(step: RenewalStep): boolean {
  return step === 'processing' || step === 'photos' || step === 'outcome';
}
